export default __webpack_public_path__ + "static/media/SG-Red-0007.a3213ac8.png";